let photoCanvas, photoVideo

function uploadFace(file) {
	const formData = new FormData()
	formData.append('face', file)

	$.ajax({
		url: $('#face-form').attr('action'), type: 'POST', data: formData, processData: false, contentType: false, success: function (response) {
			if (response && response.success && response.url) {
				$('#face-preview').attr('src', response.url)
			}
		}
	})
}

function useCapturedPhoto() {
	const context = photoCanvas.getContext('2d')

	context.drawImage(photoVideo, 0, 0, photoCanvas.width, photoCanvas.height)

	photoCanvas.toBlob(function (blob) {
		if (!blob) {
			return
		}

		const file = new File([blob], 'captured-photo.jpg', {type: 'image/jpeg'})
		uploadFace(file)
	}, 'image/jpeg')
}

$(function () {
	const page_profile_details = $('.page-profile-details')

	if (page_profile_details.length < 1) {
		return
	}

	$('#face-upload').on('click', function () {
		$('#face').trigger('click')
	})

	$('#face').on('change', function () {
		const file = this.files[0]

		if (!file) {
			return
		}

		uploadFace(file)
	})

	$('#face-photo').on('click', function () {
		popup('Arckép készítése', '/fiokom/adataim/fenykepezo', null, function () {
			photoCanvas = document.getElementById('canvas')
			photoVideo = document.getElementById('camera-stream')

			// Request webcam access and start the video stream
			async function startCamera() {
				try {
					const stream = await navigator.mediaDevices.getUserMedia({
						video: {width: photoCanvas.getAttribute('width'), height: photoCanvas.getAttribute('height')}, audio: false
					})
					photoVideo.srcObject = stream
				}
				catch (error) {
					console.error("Webcam access denied or not supported:", error)
				}
			}

			popup_buttons([{
				close: true, icon: 'fa-solid fa-xmark', class: 'btn-default', text: 'Mégsem'
			}, {
				click: 'useCapturedPhoto()', close: true, icon: 'fa-solid fa-camera', class: 'btn-primary', text: 'Kép készítése'
			}])

			// Start the camera as soon as the app loads
			startCamera()
		})
	})
})
